<div class="d-flex align-items-center">
  <!-- [{{menuItems |json}}] -->

  <ng-container *ngFor="let menu of menuItems; let index = index">
    <ng-container *ngIf="adminBreadcrumb==false||(adminBreadcrumb&&index>0)">
      <span *ngIf="adminBreadcrumb==false||(adminBreadcrumb&&index>0)" class="breadcrumb d-flex offsetY opacityIcon" [class.opacityIcon-init]="index==1&&menuItems.length==2">
        <mat-icon>
          keyboard_arrow_right
        </mat-icon>
      </span>

      <div [class.breadcrumb-color]="isLastMenu(menu.name) == false" [class.breadcrumb]="isLastMenu(menu.name) == false"
        [class.breadcrumb-last]="isLastMenu(menu.name) == true">
        <button [attr.aria-label]="menu.name" *ngIf="isLastMenu(menu.name)==false" mat-button
          class="toolbar-button offsetY" style="margin-left: -8px; margin-right: -8px;"
          [routerLink]="menu.url">{{menu.name}}</button>
        <div class="offsetY lastMenu" *ngIf="isLastMenu(menu.name)">{{menu.name}}</div>
      </div>
    </ng-container>

  </ng-container>
</div>